import { useEffect } from 'react';
import { replace } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { State } from 'reducers';
import { getBuildingByUrlSlug, getIsLoadingBuilding, HasDeviceId, HasUrlSlug, getBuildingsError } from 'selectors/buildingsSelectors';
import { getBuildingRequest } from 'actions/buildingActions';
import { PageHeader } from 'ui/shared/pageHeader';
import { BuildingAddress } from './settings/address/buildingAddress/BuildingAddress';
import { BuildingRouter } from './BuildingRouter';
import { useRouter } from 'util/reactRouterHooks';

const minWidth = {
    minWidth: '720px',
};

export const BuildingPage = () => {
    const { t } = useTranslation();

    const { match, location } = useRouter<HasUrlSlug & HasDeviceId>();
    const { pathname } = location;
    const { params } = match;
    const { urlSlug, deviceId } = params;

    const loading = useSelector((state: State) => getIsLoadingBuilding(state, params));
    const building = useSelector((state: State) => getBuildingByUrlSlug(state, params));
    const error = useSelector(getBuildingsError);
    const devices = building && building.devices;
    const device = devices && deviceId && devices[deviceId];

    const dispatch = useDispatch();

    // Load the building when urlSlug changes
    useEffect(() => {
        if (urlSlug) {
            dispatch(getBuildingRequest(urlSlug));
        }
    }, [ dispatch, urlSlug ]);
    
    // replace building id with urlSlug if not already (see M1-119 for more details)
    useEffect(() => {
        if (building && urlSlug !== building.urlSlug) {
            dispatch(replace(pathname.replace(urlSlug, building.urlSlug)));
        }
    }, [ dispatch, urlSlug, building, pathname ]);

    return (
        <div id="building-area" style={ minWidth }>
            <PageHeader
                title={ (error || !building) ? '' : loading ? t('LOADING') : building.displayName }
                subTitle={ error || loading ? '' : <BuildingAddress building={ building }/> }
                nestedTitle={ device ? (device.displayName || device.id) : undefined }
                titleLink={ device ? `/buildings/${urlSlug}` : undefined }
            />
            <div id="page-content">
                <BuildingRouter/>
            </div>
        </div>
    );
};
